module.exports = __webpack_public_path__ + "static/img/case4-bg.28de237.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case4-bg.jpg
// module id = s3Qe
// module chunks = 0